import React from "react"
import tw from "twin.macro"
import Modal from "@components/Modal"
import { buttonPurple, buttonPurpleOutline } from "@styles/ui"

import CloseButton from "@images/shared/icon_close-button.inline.svg"
import { gtmLeavingModalClick, gtmLeavingModalCancel } from '@components/Gtm'

const ModalExit = ({
  triggerContent,
  triggerStyles,
  destinationUrl,
  screenshotMode,
  targetModal,
  tabIndex,
}) => {
  const ModalContent = ({ closemodal }) => {
    return (
      <div
        data-gtm="modal-exit"
        tw="pt-6 px-6 pb-10 w-[21.4375rem] md:(w-[56.25rem] px-10 max-w-full) lg:(pt-8 px-[4.5rem] pb-[4.5rem])"
      >
        <button
          css={[tw`block ml-auto`, screenshotMode && tw`outline-none`]}
          onClick={closemodal}
          aria-label="close modal"
        >
          <CloseButton />
        </button>
        <h2 tw="leading-[0.95] text-purple font-kanit tracking-[0.005rem] font-extrabold text-[2rem] lg:(text-5xl font-bold)">
          You are being directed <br tw="hidden lg:(block)" />
          to another website.
        </h2>
        <p tw="mt-4 text-lg">
          The links to third-party websites are provided solely for your
          convenience. CorMedix does not control the opinions, claims or
          comments contained on any third-party website and your activities on
          those websites will be governed by the policies and practices of those
          third parties.
        </p>
        <div tw="mt-6 lg:(flex items-center justify-center)">
          <button
            data-gtm="modal-exit-cancel"
            css={[
              buttonPurpleOutline,
              tw`mb-4 lg:(mb-0 w-[11.8125rem] mr-2.5)`,
            ]}
            onClick={() => { gtmLeavingModalCancel(destinationUrl); closemodal(); }}
          >
            Cancel
          </button>
          <a
            data-gtm="modal-exit-continue"
            css={[buttonPurple, tw`block lg:(w-[11.8125rem] ml-2.5)`]}
            onClick={() => { gtmLeavingModalClick(destinationUrl); closemodal(); }}
            href={destinationUrl}
            target="_blank"
            rel="noreferrer"
          >
            Continue
          </a>
        </div>
      </div>
    )
  }

  return (
    <Modal
      targetModal={targetModal}
      destinationUrl={destinationUrl}
      triggerContent={triggerContent}
      triggerStyles={triggerStyles}
      modalGtmName="trigger-exit-modal"
      modalTitle="Exit modal"
      tabIndex={tabIndex}
    >
      <ModalContent />
    </Modal>
  )
}

export default ModalExit
